var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#009DA5;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path-1_00000098904924742298124210000015499861243503739821_",
    className: "st0",
    d: "M21.4,8.6c0.4,0.4,0.4,0.9,0.1,1.3l-0.1,0.1 L16.4,15l4.9,4.9c0.4,0.4,0.4,1,0,1.4c-0.4,0.4-0.9,0.4-1.3,0.1l-0.1-0.1L15,16.4l-4.9,4.9c-0.4,0.4-1,0.4-1.4,0 C8.3,21,8.2,20.4,8.6,20l0.1-0.1l4.9-4.9l-4.9-4.9c-0.4-0.4-0.4-1,0-1.4C9,8.3,9.6,8.2,10,8.6l0.1,0.1l4.9,4.9l4.9-4.9 C20.3,8.2,21,8.2,21.4,8.6z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.1e5c701a69fb93d0e1b79528ae224698.svg";
export { ForwardRef as ReactComponent };